import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {UseCaseGroupState} from '@app/flow/core/models/flow.model';

@Injectable({ providedIn: 'root' })
export class StateUseCaseGroupService {
	private _useCaseGroup$ = new BehaviorSubject<UseCaseGroupState | null>(null);

	constructor() {
	}

	get useCaseGroup$() {
		return this._useCaseGroup$.asObservable();
	}

	get useCaseGroup() {
		return this._useCaseGroup$.value;
	}

	save(state: UseCaseGroupState) {
		this._useCaseGroup$.next(state);
	}

	destroy() {
		this._useCaseGroup$.next(null);
	}
}
